export enum DrayageDetailsActionTypes {
  SET_DELIVERY_ORDER_DOCUMENT_KEY = "SET_DELIVERY_ORDER_DOCUMENT_KEY",
  SET_MASTER_BOL_NUMBER = "SET_MASTER_BOL_NUMBER",
  SET_CONTAINER_ID = "SET_CONTAINER_ID",
  SET_COMMODITY_TRANSPORTED = "SET_COMMODITY_TRANSPORTED",
  SET_DELIVERY_ORDER_FILE_NAME = "SET_DELIVERY_ORDER_FILE_NAME",
}
